export default __webpack_public_path__ + "static/media/10t.7b137971.jpg";